import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GetRole } from 'src/app/models/role/get-role';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  constructor(
    private httpClient: HttpClient
  ) { }

  private POST_ENDPOINT: string = 'Role';
  private BASE_URL: string = `${environment.sistemaWebAdmin}`;
  private REQUEST_URL: string = `${this.BASE_URL}/${this.POST_ENDPOINT}`;

  getList(parameters: any): Observable<GetRole> {
    let httpParams = new HttpParams({
      fromObject: parameters,
    });
    return this.httpClient.get<GetRole>(`${this.REQUEST_URL}/pag`, { params: httpParams });
  }

  getListAll(idEnterprise: number = 0): Observable<GetRole> {
    return this.httpClient.get<GetRole>(`${this.REQUEST_URL}/enterprise/${idEnterprise}`);
  }

  create(data: any){
    return this.httpClient.post<any>(`${this.REQUEST_URL}`,data);
  }

  update(data: any){
    return this.httpClient.put<any>(`${this.REQUEST_URL}`,data);
  }

  delete(data: any){
    return this.httpClient.patch<any>(`${this.REQUEST_URL}`,data);
  }
}
